// queries.js
import { gql } from '@apollo/client';

export const FULL_DATA_BUCKET_TREE = gql`
  query {
    fullDataBucketTree
  }
`;
export const CREATE_DATA_BUCKET = gql`
  mutation createDataBucket($name: String!, $bucketLevel: String, $parentId: ID) {
    createDataBucket(name: $name, bucketLevel: $bucketLevel, parentId: $parentId) {
      _id
      name
      bucketLevel
      parentId
      children {
        _id
        name
      }
    }
  }
`;

export const UPDATE_DATA_BUCKET = gql`
  mutation updateDataBucket($id: ID!, $name: String!, $bucketLevel: String, $parentId: ID) {
    updateDataBucket(id: $id, name: $name, bucketLevel: $bucketLevel, parentId: $parentId) {
      _id
      name
      bucketLevel
      parentId
    }
  }
`;

export const DELETE_DATA_BUCKET = gql`
  mutation deleteDataBucket($id: ID!) {
    deleteDataBucket(id: $id)
  }
`;

// Query to get the current fields
export const GET_FIELDS = gql`
  query mutation {
    GetDynamicField {
      _id
      status
      flag
      name
      department
      data {
        _id
        status
        flag
        name
      }
    }
  }
`;

// Mutation to update a field
export const UPDATE_FIELD = gql`
  mutation UpdateDynamicField($id: String, $obj: String, $newData: DynamicFieldInputType!, $key: Boolean) {
    UpdateDynamicField(id: $id, objId: $obj, newData: $newData, key: $key) {
      status
      message
      response {
        _id
        status
        name
        data {
          _id
          status
          name
          flag 
        }
      }
    }
  }
`;
export const GET_DYNAMIC_ROUTES=gql`
query {
  getSideMenu {
    name
    department
    fields {
      name
      status
      mainId
      Subfields{
      subId
      displayName
        name
        status
      } 
    }
  }
}
`
export const DAYNAMIC_ROUTES=gql`
mutation SideMENU($input: SideMenuInputType!) { 
  SideMENU(input: $input) { 
    status 
    message 
  }
}`

// Mutation to add a new field
export const ADD_NEW_FIELD = gql`
  mutation AddNewField($name: String,$Department:String) {
    CreateDynamicField(name: $name ,department:$Department) {
      status
      message
      response {
        _id
        status
        name
        data {
          _id
          status
          name
          flag
        }
      }
    }
  }
`;

// Mutation to delete a field
// It looks like the mutation to delete a field is incomplete. You might want to add that as well.
